import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useThemeContext } from "../../context/ThemeContext";
import useSoundFx from "../../hooks/useSoundFx";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  const { isDark } = useThemeContext();
  const { playClick } = useSoundFx();

  const textColor = isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.55)";

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        zIndex: 2,
        borderTop: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.08)",
        px: { xs: 3, md: 6 },
        py: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        transition: "border-color 0.3s ease",
      }}
    >
      {/* Social icons — mobile only (sidebar handles desktop) */}
      <Box
        sx={{
          display: { xs: "flex", lg: "none" },
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Typography
          sx={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.9rem",
            color: textColor,
            mr: 0.5,
          }}
        >
          Let's{" "}
          <Box component="span" sx={{ color: "#00e676", fontWeight: 600 }}>
            connect
          </Box>
        </Typography>
        {[
          { href: "https://www.linkedin.com/in/muhammadfazahardiansyah/", label: "LinkedIn", icon: <LinkedInIcon fontSize="small" />, hover: "#0a66c2" },
          { href: "https://github.com/mfazahardiansyah", label: "GitHub", icon: <GitHubIcon fontSize="small" />, hover: isDark ? "white" : "#0d1b2a" },
          { href: "mailto:fazamhdh95@gmail.com", label: "Email", icon: <EmailIcon fontSize="small" />, hover: "#00e676" },
          { href: "https://www.instagram.com/fazamuhammadh/", label: "Instagram", icon: <InstagramIcon fontSize="small" />, hover: "#e1306c" },
        ].map(({ href, label, icon, hover }) => (
          <IconButton
            key={label}
            component="a"
            href={href}
            target={href.startsWith("mailto") ? undefined : "_blank"}
            rel={href.startsWith("mailto") ? undefined : "noopener noreferrer"}
            aria-label={label}
            onClick={playClick}
            size="small"
            sx={{ color: textColor, transition: "color 0.2s", "&:hover": { color: hover } }}
          >
            {icon}
          </IconButton>
        ))}
      </Box>

      <Typography
        sx={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.9rem",
          color: textColor,
          textAlign: "center",
        }}
      >
        © {new Date().getFullYear()} All rights reserved. Designed and Developed
        By Muhammad Faza Hardiansyah
      </Typography>
    </Box>
  );
};

export default Footer;
